import React from 'react'
import configuredAxios from 'lib/utils/axios'
import { proxyUrl } from 'lib/utils/proxy'

import { ReactQueryConfigProvider } from 'react-query'

const reactQueryConfig = {
  queries: {
    retry: false,
    queryFn: async key => {
      if (!key) return
      const { data } = await configuredAxios.get(proxyUrl({ link: key }))
      return data
    },
  },
}

const ConfiguredReactQueryProvider = ({ children }) => (
  <ReactQueryConfigProvider config={reactQueryConfig}>
    {children}
  </ReactQueryConfigProvider>
)

export default ConfiguredReactQueryProvider
